import { useGetAllExamCentersQuery } from '@exam-center/graphql';
import { useMemo } from 'react';

import { BaseSearchSelection } from '../../components';

interface ExamCenterSearchSelectionProps {
  value: string[];
  onChange: (value: string[]) => void;
}

export default function ExamCenterSearchSelection(props: Readonly<ExamCenterSearchSelectionProps>) {
  const { value, onChange } = props;
  const { data } = useGetAllExamCentersQuery();

  const examCenterOptions = useMemo(() => {
    return [...(data?.ecGetAllExamCenters?.examCenters ?? [])]
      .sort((a, b) => a.examCenterId - b.examCenterId)
      .map((examCenter) => ({
        label: examCenter.code,
        value: examCenter.code,
      }));
  }, [data]);

  return (
    <BaseSearchSelection
      options={examCenterOptions}
      label='ศูนย์ทดสอบ'
      value={value}
      onChange={onChange}
    />
  );
}
